import React, { useState } from 'react';
import { Box, Button, Typography, makeStyles, Avatar } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Countdown from 'react-countdown';
import moment from 'moment';

const useStyle = makeStyles((theme) => {
  return {
    main: {
      display: 'flex',
      flex: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    },
    comingSoon: {
      marginTop: 40,
      color: theme.text.tertiary,
    },
    clockBox: {
      [theme.breakpoints.down('sm')]: {
        margin: '0px 8px',
      },
      margin: '0px 32px',
      textAlign: 'center',
    },
    clock: {
      color: theme.text.tertiary,
      fontSize: 32,
      [theme.breakpoints.down('sm')]: {
        fontSize: 24,
      },
    },
    caption: {
      color: theme.text.item,
      fontSize: 24,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },

    submit: {
      margin: '0 auto',
    },
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
    },
    mizbanLogo: {
      width: 64,
      height: 64,
    },
  };
});

const Jobs = () => {
  const classes = useStyle();
  const [date, setDate] = useState(moment().format('2023-01-01T10:36:00'));

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      setDate(moment().format('2023-01-11T10:36'));
      return null;
    } else {
      return (
        <span>
          <Box display='flex'>
            <Box className={classes.clockBox}>
              <Dates>{days}</Dates>
              <Caption>Days</Caption>
            </Box>
            <Box className={classes.clockBox}>
              <Dates>{hours}</Dates>
              <Caption>Hours</Caption>
            </Box>
            <Box className={classes.clockBox}>
              <Dates>{minutes}</Dates>
              <Caption>Minutes</Caption>
            </Box>
            <Box className={classes.clockBox}>
              <Dates>{seconds}</Dates>
              <Caption>Seconds</Caption>
            </Box>
          </Box>
        </span>
      );
    }
  };

  const Dates = ({ children }) => {
    return <Typography className={classes.clock}>{children}</Typography>;
  };
  const Caption = ({ children }) => {
    return <Typography className={classes.caption}>{children}</Typography>;
  };

  return (
    <Box className={classes.main} my={5}>
      <Box>
        <Box className={classes.container} mb={5}>
          <Avatar
            className={classes.mizbanLogo}
            // eslint-disable-next-line no-undef
            src={process.env.PUBLIC_URL + '/icons/mizban.svg'}
          />
          <Typography color='primary' variant='h6'>
            Mizban
          </Typography>
        </Box>

        <Box className={classes.container}>
          <Countdown renderer={renderer} date={date} />

          <Typography className={classes.comingSoon} variant='h5'>
            We are coming soon with something new!!
          </Typography>
        </Box>

        <Box display='flex' mt={5}>
          <Button
            className={classes.submit}
            variant='contained'
            size='small'
            color='primary'
            component={Link}
            to='/'
          >
            Back to Main
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Jobs;
